import { useState, useCallback } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'

function useCancelFee({ subscriptionId }) {
  const [feeData, setFeeData] = useState(null)
  const { getData, isLoading: isFeeLoading, error: feeError } = useApiGet()

  const fetchFee = useCallback(() => new Promise((resolve) => {
    getData({
      path: `/api/subscriptions/calculate_subscription_cancel_fee/${subscriptionId}`,
      onSuccess: (response) => {
        setFeeData(response.data)
        resolve(response.data)
      },
      onError: () => {
        resolve(null)
      },
    })
  }), [getData, subscriptionId])

  const resetFeeData = useCallback(() => {
    setFeeData(null)
  }, [])

  return { feeData, isFeeLoading, feeError, fetchFee, resetFeeData }
}

export default useCancelFee
